import { useEffect } from 'react'
import { useUserSettings } from '../api/hooks/useSettings'
import { useUIStore } from '../stores/uiStore'
import { useAuth } from '../stores/authStore'

/**
 * Hook to hydrate Zustand store with enabledSections from database on app startup
 * This ensures the UI state is synchronized with the database
 */
export const useSectionHydration = () => {
  const { user } = useAuth()
  const { data: userSettings } = useUserSettings()
  const { setEnabledSections } = useUIStore()

  useEffect(() => {
    // Only hydrate if user is authenticated and we have settings
    if (user && userSettings?.enabledSections) {
      setEnabledSections(userSettings.enabledSections)
    }
  }, [user, userSettings?.enabledSections, setEnabledSections])
}
